var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain-inside"},[_c('QuestionRadioOptions',{attrs:{"item":_vm.item,"editable":true},on:{"edit_clicked":_vm.edit_clicked,"selected":_vm.selected_option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }